import * as React from "react";
import { forwardRef } from "react";
const SvgActiveChecked = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 22, height: 22, viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 0.5, y: 0.5, width: 21, height: 21, rx: 2.5, fill: "#5265FF", stroke: "#182231" }), /* @__PURE__ */ React.createElement("path", { d: "M15.5802 6.58008L16.9902 8.00008L8.99023 16.0001L4.99023 12.0101L6.41023 10.6001L8.99023 13.1701L15.5802 6.58008Z", fill: "white" }));
const ForwardRef = forwardRef(SvgActiveChecked);
export { ForwardRef as ReactComponent };
